import React, { FC, useCallback, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Article } from 't2-graphql-types';
import compact from 'lodash/compact';
import { getArticleRepliesQuery } from './queries/getArticleRepliesQuery';
import { TArticleRepliesSectionProps } from './types';
import { PaginatedArticlesList } from '../PaginatedArticlesList/PaginatedArticlesList';
import { PAGE_SIZE } from './constants';
import { ArticleType } from '../Article/types';

export const ArticleRepliesSection: FC<TArticleRepliesSectionProps> = ({ articleId }) => {
  const [getArticleReplies, { data, loading, error, fetchMore }] = useLazyQuery<{
    article: Article;
  }>(getArticleRepliesQuery, {
    variables: { articleId, take: PAGE_SIZE, skip: 0, type: ArticleType.Article },
  });
  const sortedChildArticles = data?.article?.sortedChildArticles || [];
  const sortedChildArticlesArray = compact(sortedChildArticles?.map((article) => article?.childArticles?.[0]));

  const getNextArticleReplies = useCallback((variables) => getArticleReplies({ variables }), [getArticleReplies]);

  useEffect(() => {
    getArticleReplies();
  }, []);

  return (
    <div className="mb-24">
      <PaginatedArticlesList
        listSection={{
          title: 'Replies to this Post',
          loading,
        }}
        content={{
          items: sortedChildArticlesArray,
          itemCount: data?.article?.childArticlesCount || 0,
          loading,
          error: !!error,
          refetch: getNextArticleReplies,
          emptyMessage: 'There are no replies to this post yet. Be the first!',
          fetchMore,
        }}
        pageSize={PAGE_SIZE}
      />
    </div>
  );
};
